import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	error: { status: false, message: "" },
	success: { status: false, message: "" },
	warning: { status: false, message: "", items: [] },
	loading: false,
	isHistoryDrawerOpen: false,
	showData: { isRedirected: false, data: {} },
	isLoggedInFromFeedbackUrl: false, // flag to check if user logged in from feedback url
};

export const commonSlice = createSlice({
	name: "commonData",
	initialState,
	reducers: {
		setError: (state, { payload }) => {
			state.error = { status: true, message: payload.message };
		},
		removeError: (state) => {
			state.error = { status: false, message: "" };
		},
		setSuccess: (state, { payload }) => {
			state.success = { status: true, message: payload.message };
		},
		removeSuccess: (state) => {
			state.success = { status: false, message: "" };
		},
		setWarning: (state, { payload }) => {
			state.warning = {
				status: true,
				message: payload.message,
				items: payload.items || [],
			};
		},
		removeWarning: (state) => {
			state.warning = { status: false, message: "", items: [] };
		},
		setLoading: (state, { payload }) => {
			state.loading = payload.loading;
		},
		openHistoryDrawer: (state, { payload }) => {
			state.isHistoryDrawerOpen = payload.historyDrawerState;
		},
		setShowData: (state, { payload }) => {
			state.showData = {
				isRedirected: payload.showDataState,
				data: payload.showData,
			};
		},
		setFeedbackLoginFlag: (state, { payload }) => {
			state.isLoggedInFromFeedbackUrl = payload.isLoggedInFromFeedbackUrl;
		},
	},
});
